import { api_GET, api_POST, api_PUT } from "./_api.js";

const regionais_api = {
    getList: (status) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Regionais/getlist/${status ? status : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Regionais/getitem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (regional) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Regionais`, regional)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (regional) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Regionais`, regional)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default regionais_api;
